import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService, TranslatePipe, TranslateDirective } from "@ngx-translate/core";

import { HeaderComponent} from './core/header/header.component';
import { FooterComponent} from './core/footer/footer.component';
import { SidenavComponent} from './core/sidenav/sidenav.component';

import { MatSidenavModule } from '@angular/material/sidenav';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    CommonModule,
    HeaderComponent,
    FooterComponent,
    SidenavComponent,
    MatSidenavModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  //================================================================================================
  //  変数定義
  //============================|===================================================================
  isProvider                    = true;                                                            //
  //================================================================================================
  //  コンストラクタ
  //============================|===================================================================
  constructor(private router: Router,
              private translate: TranslateService) {
    translate.setDefaultLang('ja');
    translate.addLangs(['ja','en']);
    let opca_language = localStorage.getItem('opca_language');
    if (opca_language=='ja' || opca_language=='en') {
      translate.use(opca_language);
    } else {
      translate.use('ja');
    }
    //  呼び出しURLのチェック
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const array = ['/login', '/signup', '/twofactor', '/mail-action', '/sys-admin', '/group', '/log-mg', '/dashboard', '/config', '/op-admin', '/op-user', '/opr', '/api-account', '/keys-versions', '/wsp', '/ca']
        this.isProvider = false;
        if (event.url.startsWith("/authorize")) {
          this.isProvider = true;
        }
        if (!array.includes(event.url)) {
          this.isProvider = true;
        }
      }
    });
  }
  title = 'facere-opca-angular';
}
